/**
 * @vuelto-surface
 * mobile: n/a
 * desktop: ok
 * strategy: web-only
 */
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography';

type Props = {
  targetEmail: string | null | undefined;
  expiresAtLabel: string;
  exiting: boolean;
  onExit: () => void;
};

export function ImpersonationBanner({ targetEmail, expiresAtLabel, exiting, onExit }: Props) {
  return (
    <View style={styles.wrap} accessibilityRole="alert">
      <Text style={styles.text}>
        Modo soporte: viendo como {targetEmail?.trim() || 'usuario'}. Expira {expiresAtLabel}.
      </Text>
      <TouchableOpacity
        style={[styles.button, exiting && styles.buttonDisabled]}
        onPress={onExit}
        disabled={exiting}
        accessibilityRole="button"
        accessibilityLabel="Salir de impersonación"
      >
        <Text style={styles.buttonText}>{exiting ? 'Saliendo…' : 'Salir'}</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    backgroundColor: '#5c3b14',
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: '#c9a227',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    gap: spacing.sm,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  text: {
    ...typography.caption,
    color: '#ffe8a3',
    flex: 1,
    paddingRight: spacing.sm,
  },
  button: {
    backgroundColor: '#ffe8a3',
    borderRadius: 6,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.xs,
  },
  buttonDisabled: {
    opacity: 0.6,
  },
  buttonText: {
    ...typography.caption,
    color: '#3d2a0a',
    fontWeight: '600',
  },
});
